import { gql, useMutation, useQuery } from '@apollo/client'

import {
  GachaTicketSerialQuery,
  GachaTicketSerialQueryVariables,
  ObtainGachaTicketSerialMutation,
  ObtainGachaTicketSerialMutationVariables,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, fragments, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  const { router } = useRouter<{ gachaTicketId: string; serialId: string }>()
  const { gachaTicketId, serialId } = router.query || {}

  const { data, loading: queryLoading } = useQuery<
    GachaTicketSerialQuery,
    GachaTicketSerialQueryVariables
  >(GACHA_TICKET_SERIAL, {
    variables: { id: gachaTicketId, serialId },
  })

  const [obtain, { loading: submitting }] = useMutation<
    ObtainGachaTicketSerialMutation,
    ObtainGachaTicketSerialMutationVariables
  >(OBTAIN_GACHA_TICKET_SERIAL, {
    variables: { id: gachaTicketId, serialId },
  })

  return {
    state: {
      loading: queryLoading,
      submitting,
      user,
      gachaTicket: data?.gachaTicket ?? null,
    },
    actions: {
      async onGetGachaTicket() {
        await obtain()
      },
    },
  }
})

const GACHA_TICKET_SERIAL = gql`
  query GachaTicketSerial($id: ID!, $serialId: ID!) {
    user {
      id
      gachaTicket(id: $id) {
        available
      }
    }
    gachaTicket(id: $id) {
      ...gachaTicket
      serial(id: $serialId) {
        ...gachaTicketSerial
      }
    }
  }
  ${fragments.gachaTicket}
  ${fragments.gachaTicketSerial}
`

const OBTAIN_GACHA_TICKET_SERIAL = gql`
  mutation ObtainGachaTicketSerial($id: String!, $serialId: String!) {
    obtainGachaTicketSerial(gachaTicketId: $id, serialId: $serialId) {
      ...gachaTicketOrder
    }
  }
  ${fragments.gachaTicketOrder}
`
